import css from 'styled-jsx/css';

import { screen } from 'components/styles/variables';
import loadingbox from 'public/static/images/srp/Loading_Image.svg';

export const sliderCss = css.resolve`
  @media (min-width: ${screen.smMin}) {
    .slider :global(.slider-frame) {
      border-radius: 16px;
    }
  }
  @media (min-width: ${screen.mdMin}) {
    .slider :global(.slider-control-bottomcenter) {
      display: none;
    }
  }
  .slider :global(.slider-slide:after) {
    display: block;
    content: '';
    /* 16:10 aspect ratio */
    padding-bottom: 62.5%;
  }
  .slider :global(.slider-control-bottomcenter) {
    margin-bottom: 16px;
  }
  .image-slide {
    object-fit: cover;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 232px;
  }
  @media (min-width: ${screen.smMin}) {
    .image-slide {
      height: 365px;
    }
  }
  @media (max-width: ${screen.xsMax}) {
    .image-slide {
      height: 240px;
    }
  }
`;

export const heartCss = css.resolve`
  position: absolute;
  top: 16px;
  right: 16px;
`;

export const counterCss = css.resolve`
  .counter {
    display: none;
    position: absolute;
    bottom: 16px;
    right: 16px;
  }
  @media (min-width: ${screen.mdMin}) {
    .counter {
      display: flex;
    }
  }
`;

export default `
  .image-slide-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .placemat {
    border-radius: 16px;
    width: 100%;
    position: absolute;
    background-image: url(${loadingbox});
  }
  .sizer {
    margin-bottom: 86px;
  }
  .dots-container {
    bottom: 0px;
    position: absolute;
    left: 45%;
    display: none;
  }
  @media (max-width: ${screen.xsMax}) {
    .placemat {
      border-radius: 0;
    }
    .placemat,
    .sizer,
    .vdp-carousel-wrapper {
      height: 232px;
    }
    .dots-container {
      display: block;
    }
  }
  @media (min-width: ${screen.smMin}) and (max-width: ${screen.smMax}) {
    .sizer,
    .vdp-carousel-wrapper {
      height: 449px;
    }
    .placemat {
      height: auto;
    }
    .sizer {
      margin-bottom: 35px;
    }
    .image-slide-image {
      height: 100%;
      border-radius: 16px;
    }
    .dots-container {
      bottom: 100px;
      display: block;
    }
  }
  @media (min-width: ${screen.mdMin}) and (max-width: ${screen.mdMax}) {
    .placemat,
    .sizer,
    .vdp-carousel-wrapper {
      height: 308px;
    }
    .sizer {
      margin-bottom: 155px;
    }
    .image-slide-image {
      border-radius: 16px;
    }
  }
  @media (min-width: ${screen.lgMin}) {
    .placemat,
    .sizer,
    .vdp-carousel-wrapper {
      height: 365px;
    }
    .sizer {
      margin-bottom: 114px;
    }
    .image-slide-image {
      height: 100%;
      border-radius: 16px;
    }
  }
  .sizer {
    position: relative;
    width: 100%;
  }
  .vdp-carousel-wrapper {
    left: 0px;
    top: 0px;
    right: 0px;
    bottom: 0px;
  }
  .vehicle-badges {
    position: absolute;
    bottom: 16px;
    left: 16px;
  }
`;
